import { c as _c } from "react/compiler-runtime";
import { t, SupportedLocale } from "@/lib/i18n";
import { trackProductOfferClick } from "@/lib/analytics";
import { formatOfferPrice, getProductOffers, hasOfferPrice, type ResolvedProductOffer } from "@/data/productOffers";
import styles from "@/styles/Home.module.css";
type ProductTopOffersProps = {
  productId: string;
  productName: string;
  locale: SupportedLocale;
};
export function ProductTopOffers(t0) {
  const $ = _c(35);
  const {
    productId,
    productName,
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== locale || $[1] !== productId || $[2] !== productName) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const offers = getProductOffers(productId);
      if (!offers.length) {
        t6 = null;
        break bb0;
      }
      const bestOfferStoreId = offers.find(hasOfferPrice)?.storeId;
      t3 = "product-top-offers";
      t4 = styles.topOffers;
      let t7;
      if ($[9] !== locale || $[10] !== productName) {
        t7 = t(locale, "product.topOffersTitle").replace("{name}", productName);
        $[9] = locale;
        $[10] = productName;
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      let t8;
      if ($[12] !== t7) {
        t8 = <h2 className={styles.topOffersTitle}>{t7}</h2>;
        $[12] = t7;
        $[13] = t8;
      } else {
        t8 = $[13];
      }
      let t9;
      if ($[14] !== locale || $[15] !== productName) {
        t9 = t(locale, "product.topOffersSubtitle").replace("{name}", productName);
        $[14] = locale;
        $[15] = productName;
        $[16] = t9;
      } else {
        t9 = $[16];
      }
      let t10;
      if ($[17] !== t9) {
        t10 = <p className={styles.topOffersSubtitle}>{t9}</p>;
        $[17] = t9;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      if ($[19] !== t10 || $[20] !== t8) {
        t5 = <div className={styles.topOffersHeader}>{t8}{t10}</div>;
        $[19] = t10;
        $[20] = t8;
        $[21] = t5;
      } else {
        t5 = $[21];
      }
      t1 = styles.topOffersList;
      t2 = offers.map((offer, index) => <OfferRow key={`${offer.storeId}-${offer.price ?? "browse"}`} offer={offer} rank={index + 1} isBest={offer.storeId === bestOfferStoreId} locale={locale} productId={productId} />);
    }
    $[0] = locale;
    $[1] = productId;
    $[2] = productName;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[22] !== t1 || $[23] !== t2) {
    t7 = <ol className={t1}>{t2}</ol>;
    $[22] = t1;
    $[23] = t2;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== locale) {
    t8 = t(locale, "product.topOffersNote");
    $[25] = locale;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t8) {
    t9 = <p className={styles.topOffersNote}>{t8}</p>;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t7 || $[33] !== t9) {
    t10 = <div id={t3} className={t4}>{t5}{t7}{t9}</div>;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t7;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
function OfferRow(t0) {
  const $ = _c(61);
  const {
    offer,
    rank,
    isBest,
    locale,
    productId
  } = t0;
  let t1;
  if ($[0] !== locale || $[1] !== offer.storeLabelKey) {
    t1 = t(locale, offer.storeLabelKey);
    $[0] = locale;
    $[1] = offer.storeLabelKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const storeLabel = t1;
  let t2;
  if ($[3] !== offer) {
    t2 = hasOfferPrice(offer);
    $[3] = offer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const priced = t2;
  let t3;
  if ($[5] !== locale || $[6] !== offer.currency || $[7] !== offer.price || $[8] !== priced) {
    t3 = priced ? formatOfferPrice(offer.price, offer.currency ?? "USD") : t(locale, "product.offerPriceUnknown");
    $[5] = locale;
    $[6] = offer.currency;
    $[7] = offer.price;
    $[8] = priced;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const priceLabel = t3;
  let t4;
  if ($[10] !== locale || $[11] !== offer.shippingIncluded || $[12] !== priced) {
    t4 = priced && offer.shippingIncluded != null ? offer.shippingIncluded ? t(locale, "product.offerShippingIncluded") : t(locale, "product.offerShippingExtra") : null;
    $[10] = locale;
    $[11] = offer.shippingIncluded;
    $[12] = priced;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const shippingLabel = t4;
  let t5;
  if ($[14] !== locale || $[15] !== offer.couponCode || $[16] !== offer.couponPercent) {
    t5 = offer.couponCode && offer.couponPercent ? t(locale, "product.offerCoupon").replace("{code}", offer.couponCode).replace("{percent}", String(offer.couponPercent)) : null;
    $[14] = locale;
    $[15] = offer.couponCode;
    $[16] = offer.couponPercent;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const couponLabel = t5;
  const t6 = `${styles.topOfferRow} ${isBest ? styles.topOfferRowBest : ""}`;
  let t7;
  if ($[18] !== rank) {
    t7 = <span className={styles.topOfferRank} aria-hidden={true}>{rank}</span>;
    $[18] = rank;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== offer.logoSrc) {
    t8 = <span className={styles.topOfferLogoWrap}><img src={offer.logoSrc} alt="" className={styles.topOfferLogo} /></span>;
    $[20] = offer.logoSrc;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== storeLabel) {
    t9 = <span className={styles.topOfferStoreName}>{storeLabel}</span>;
    $[22] = storeLabel;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== isBest || $[25] !== locale) {
    t10 = isBest ? <span className={styles.topOfferBadge}>{t(locale, "product.topOfferBest")}</span> : null;
    $[24] = isBest;
    $[25] = locale;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className={styles.topOfferStoreMeta}>{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t8) {
    t12 = <div className={styles.topOfferStore}>{t8}{t11}</div>;
    $[30] = t11;
    $[31] = t8;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const t13 = `${styles.topOfferPrice}${priced ? "" : ` ${styles.topOfferPriceUnknown}`}`;
  let t14;
  if ($[33] !== priceLabel || $[34] !== t13) {
    t14 = <span className={t13}>{priceLabel}</span>;
    $[33] = priceLabel;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== shippingLabel) {
    t15 = shippingLabel ? <span className={styles.topOfferShipping}>{shippingLabel}</span> : null;
    $[36] = shippingLabel;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== couponLabel) {
    t16 = couponLabel ? <span className={styles.topOfferCoupon}>{couponLabel}</span> : null;
    $[38] = couponLabel;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t14 || $[41] !== t15 || $[42] !== t16) {
    t17 = <div className={styles.topOfferPriceBlock}>{t14}{t15}{t16}</div>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  const t18 = offer.href;
  let t19;
  if ($[44] !== offer.href || $[45] !== offer.storeId || $[46] !== productId || $[47] !== storeLabel) {
    t19 = () => trackProductOfferClick({
      productId,
      partnerId: offer.storeId,
      partnerLabel: storeLabel,
      destinationUrl: offer.href
    });
    $[44] = offer.href;
    $[45] = offer.storeId;
    $[46] = productId;
    $[47] = storeLabel;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== locale) {
    t20 = t(locale, "product.offerVisitStore");
    $[49] = locale;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== offer.href || $[52] !== t19 || $[53] !== t20) {
    t21 = <a href={t18} target="_blank" rel="nofollow noopener noreferrer sponsored" className={styles.topOfferCta} onClick={t19}>{t20}</a>;
    $[51] = offer.href;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t12 || $[56] !== t17 || $[57] !== t21 || $[58] !== t6 || $[59] !== t7) {
    t22 = <li className={t6}>{t7}{t12}{t17}{t21}</li>;
    $[55] = t12;
    $[56] = t17;
    $[57] = t21;
    $[58] = t6;
    $[59] = t7;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  return t22;
}